package org.zq.flvtomp4.platform

import androidx.compose.foundation.layout.Box
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.ui.Modifier
import kotlinx.browser.document
import org.w3c.dom.DragEvent
import org.w3c.dom.events.Event
import org.w3c.files.get

@Composable
actual fun PlatformFileDrop(
    onFilesDropped: (List<String>) -> Unit,
    modifier: Modifier,
    content: @Composable () -> Unit,
) {
    val latest = rememberUpdatedState(onFilesDropped)

    DisposableEffect(Unit) {
        val onDragOver: (Event) -> Unit = { event ->
            event.preventDefault()
            (event as? DragEvent)?.dataTransfer?.dropEffect = "copy"
        }
        val onDrop: (Event) -> Unit = drop@{ event ->
            event.preventDefault()
            event.stopPropagation()
            val dragEvent = event as? DragEvent ?: return@drop
            val fileList = dragEvent.dataTransfer?.files ?: return@drop
            val files = buildList {
                for (i in 0 until fileList.length) {
                    fileList[i]?.let { add(it) }
                }
            }
            val paths = WebFileStore.registerInputs(files)
            if (paths.isNotEmpty()) {
                latest.value(paths)
            }
        }

        document.addEventListener("dragover", onDragOver)
        document.addEventListener("drop", onDrop)
        onDispose {
            document.removeEventListener("dragover", onDragOver)
            document.removeEventListener("drop", onDrop)
        }
    }

    Box(modifier = modifier) {
        content()
    }
}
